import axios from 'axios'
import { allSitesConst } from '../../../modules/sitesConst'

export const companiesVisitorStore = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
  },
  mutations: {
    readStore(state) {
      state.loading = true
      state.loadError = false
    },
    readStoreSuccess(state, payload) {
      state.data = payload.data
      const storeSites = state.data.attributes.store_sites

      state.data.attributes.store_sites = allSitesConst.map((site) => {
        const matchedSite = storeSites.find((storeSite) => storeSite.site_type === site.siteType)
        if (!matchedSite) return null

        return {
          ...site,
          id: matchedSite ? matchedSite.id : null,
          url: matchedSite ? matchedSite.url : '',
          visible: matchedSite ? matchedSite.visible : false,
        }
      }).filter(v => v)
      state.loading = false
      state.loadError = false

    },
    readStoreFailure(state) {
      state.loading = false
      state.loadError = true
    },
    updateStore(state) {
      state.loading = true
      state.message = null
    },
    updateStoreSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
    },
    updateStoreFailure(state) {
      state.message = null
      state.loading = false
    },
    updateStoreMultiForm(state, payload) {
      state.data.attributes.store_multi_language_cover = payload
    },
    updateStoreMultiFormElement(state, { property, text }) {
      state.data.attributes.store_multi_language_cover[property] = text
    },
  },
  getters: {
    /**
     * Store にいずれかの Social 設定がされているか
     * @param  { Object } state
     * @return { Boolean }
     */
    hasSocial(state) {
      if (!state.data) return
      const { facebook_url, instagram_url, line_url, twitter_url } = state.data.attributes.store_social
      return facebook_url || instagram_url || line_url || twitter_url
    },
    /**
     * Store にいずれかの Site 表示設定がされているか
     * @param  { Object } state
     * @return { Boolean }
     */
    hasSite(state) {
      if (!state.data) return
      return state.data.attributes.store_sites.some(site => site.visible)
    },
    /**
     * Store の Social 設定
     * @param  { Object } state
     * @return { Object }
     */
    socialSettings(state) {
      if (!state.data) return
      return state.data.attributes.store_social
    },
    hasStoreMessage(state) {
      if (!state.data) return
      const { comment, url, image_url } = state.data.attributes.store_message
      return comment || url || image_url
    },
  },
  actions: {
    readStore({ commit }, { company_uuid, uuid }) {
      commit('readStore')
      return axios
        .get('/api/companies/' + company_uuid + '/visitor/stores/' + uuid + '/edit.json', {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          commit('readStoreSuccess', res.data)
        })
        .catch(err => {
          commit('readStoreFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    updateStore({ commit }, {company_uuid, uuid, store_form_data}) {
      commit('flash/clearFlash', null, { root: true })
      commit('updateStore')
      return axios
        .put('/api/companies/' + company_uuid + '/visitor/stores/' + uuid + '.json', store_form_data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          commit('updateStoreSuccess', res.data)
          commit('flash/updateFlash', { type: 'notice', message: res.data.message }, { root: true })
        })
        .catch(err => {
          console.error(err)
          commit('updateStoreFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    updateStoreMultiForm({ commit }, payload) {
      commit('updateStoreMultiForm', payload)
    },
    updateStoreMultiFormElement({ commit }, { property, text }) {
      commit('updateStoreMultiFormElement', { property, text })
    }
  }
}
